module.exports = __webpack_public_path__ + "static/media/schema2.967f5793.jpg";